var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F5F5F5;}\r\n\t.st1{fill:#E0E0E0;}\r\n\t.st2{fill:#925B97;}\r\n\t.st3{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st4{opacity:0.1;enable-background:new    ;}\r\n\t.st5{fill:#EBEBEB;}\r\n\t.st6{fill:#FAFAFA;}\r\n\t.st7{fill:#37474F;}\r\n\t.st8{fill:#455A64;}\r\n\t.st9{fill:#263238;}\r\n\t.st10{opacity:0.15;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floor_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Floor_10_",
    className: "st0",
    d: "M87.5,450.3c91.7,48.3,240.4,48.3,332,0c91.7-48.3,91.7-126.7,0-175s-240.4-48.3-332,0 C-4.2,323.6-4.2,401.9,87.5,450.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_2_",
    className: "st1",
    d: "M139.2,426.2l4.3,2.4c1.4,0.8,3.6,0.8,4.9,0L345,315.1c1.4-0.8,1.4-2.1,0-2.8l-4.2-2.4 c-1.4-0.8-3.6-0.8-4.9,0L139.2,423.4C137.8,424.2,137.8,425.4,139.2,426.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Tabs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab_10_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_56_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st2",
    d: "M144.5,423.4l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3V127c0-1.6,1.1-3.5,2.5-4.3L331.5,14.1 c1.4-0.8,3.6-0.8,5,0l0.9,0.5c1.4,0.8,2.5,2.7,2.5,4.3v291.6c0,1.6-1.1,3.5-2.5,4.3L149.5,423.4 C148.1,424.1,145.9,424.1,144.5,423.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    className: "st3",
    d: "M339.9,18.5c-0.2-1.3-1.2-1.8-2.5-1L149.5,126c-0.7,0.4-1.3,1.1-1.8,1.9l-5.9-3.4 c0.4-0.8,1.1-1.5,1.8-1.9L331.5,14.1c1.4-0.8,3.6-0.8,5,0l0.9,0.5C338.6,15.3,339.7,17,339.9,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    className: "st4",
    d: "M149.1,423.5c-1.4,0.6-3.3,0.5-4.6-0.2l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3V126.9 c0-0.8,0.3-1.7,0.7-2.5l5.9,3.4c-0.4,0.8-0.7,1.7-0.7,2.5v291.6C147,423.3,147.9,424,149.1,423.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tabs_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab_9_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st5",
    d: "M169.1,317.9l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3v-52.4c0-1.6,1.1-3.5,2.5-4.3l170.6-98.6 c1.4-0.8,3.6-0.8,5,0l0.9,0.5c1.4,0.8,2.5,2.7,2.5,4.3V215c0,1.6-1.1,3.5-2.5,4.3l-170.6,98.6 C172.8,318.7,170.5,318.7,169.1,317.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st6",
    d: "M347.2,162.2c-0.2-1.3-1.2-1.8-2.5-1l-170.6,98.6c-0.7,0.4-1.3,1.1-1.8,1.9l-5.9-3.4 c0.4-0.8,1.1-1.5,1.8-1.9l170.6-98.6c1.4-0.8,3.6-0.8,5,0l0.9,0.5C346,159,347.1,160.6,347.2,162.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st1",
    d: "M173.7,318.1c-1.4,0.6-3.3,0.5-4.6-0.2l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3v-52.4 c0-0.8,0.3-1.7,0.7-2.5l5.9,3.4c-0.4,0.8-0.7,1.7-0.7,2.5v52.4C171.6,317.9,172.5,318.5,173.7,318.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st2",
    d: "M198.3,256.2c9.7-5.6,17.6-1.2,17.6,9.8c0,11-7.9,24.4-17.6,29.9 c-9.7,5.5-17.6,1.1-17.6-9.8C180.6,275.2,188.5,261.8,198.3,256.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tab_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_46_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st5",
    d: "M169.1,388.9l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3v-52.4c0-1.6,1.1-3.5,2.5-4.3l170.6-98.6 c1.4-0.8,3.6-0.8,5,0l0.9,0.5c1.4,0.8,2.5,2.7,2.5,4.3V286c0,1.6-1.1,3.5-2.5,4.3l-170.6,98.6 C172.8,389.7,170.5,389.7,169.1,388.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st6",
    d: "M347.2,233.2c-0.2-1.3-1.2-1.8-2.5-1l-170.6,98.6c-0.7,0.4-1.3,1.1-1.8,1.9l-5.9-3.4 c0.4-0.8,1.1-1.5,1.8-1.9l170.6-98.6c1.4-0.8,3.6-0.8,5,0l0.9,0.5C346,230,347.1,231.7,347.2,233.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st1",
    d: "M173.7,389.1c-1.4,0.6-3.3,0.5-4.6-0.2l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3v-52.4 c0-0.8,0.3-1.7,0.7-2.5l5.9,3.4c-0.4,0.8-0.7,1.7-0.7,2.5v52.4C171.6,388.9,172.5,389.6,173.7,389.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st2",
    d: "M198.3,327.2c9.7-5.6,17.6-1.2,17.6,9.8s-7.9,24.4-17.6,29.9c-9.7,5.5-17.6,1.1-17.6-9.8 C180.6,346.2,188.5,332.8,198.3,327.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tab_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st5",
    d: "M169.1,199.1l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3v-52.4c0-1.6,1.1-3.5,2.5-4.3L338.8,39 c1.4-0.8,3.6-0.8,5,0l0.9,0.5c1.4,0.8,2.5,2.7,2.5,4.3v52.4c0,1.6-1.1,3.5-2.5,4.3l-170.6,98.6 C172.8,199.9,170.5,199.9,169.1,199.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st6",
    d: "M347.2,43.4c-0.2-1.3-1.2-1.8-2.5-1L174.1,141c-0.7,0.4-1.3,1.1-1.8,1.9l-5.9-3.4 c0.4-0.8,1.1-1.5,1.8-1.9L338.8,39c1.4-0.8,3.6-0.8,5,0l0.9,0.5C346,40.2,347.1,41.9,347.2,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st1",
    d: "M173.7,199.3c-1.4,0.6-3.3,0.5-4.6-0.2l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3v-52.4 c0-0.8,0.3-1.7,0.7-2.5l5.9,3.4c-0.4,0.8-0.7,1.7-0.7,2.5v52.4C171.6,199.1,172.5,199.8,173.7,199.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st2",
    d: "M198.3,137.4c9.7-5.6,17.6-1.2,17.6,9.8s-7.9,24.4-17.6,29.9c-9.7,5.5-17.6,1.1-17.6-9.8 C180.6,156.4,188.5,143,198.3,137.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tab_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st7",
    d: "M181.1,265.6l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3v-52.4c0-1.6,1.1-3.5,2.5-4.3l170.6-98.6 c1.4-0.8,3.6-0.8,5,0l0.9,0.5c1.4,0.8,2.5,2.7,2.5,4.3v52.4c0,1.6-1.1,3.5-2.5,4.3l-170.6,98.6 C184.8,266.4,182.5,266.4,181.1,265.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st8",
    d: "M359.2,109.9c-0.2-1.3-1.2-1.8-2.5-1l-170.6,98.6c-0.7,0.4-1.3,1.1-1.8,1.9l-5.9-3.4 c0.4-0.8,1.1-1.5,1.8-1.9l170.6-98.6c1.4-0.8,3.6-0.8,5,0l0.9,0.5C358,106.7,359,108.4,359.2,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st9",
    d: "M185.7,265.8c-1.4,0.6-3.3,0.5-4.6-0.2l-0.9-0.5c-1.4-0.8-2.5-2.7-2.5-4.3v-52.4 c0-0.8,0.3-1.7,0.7-2.5l5.9,3.4c-0.4,0.8-0.7,1.7-0.7,2.5v52.4C183.6,265.6,184.5,266.3,185.7,265.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st0",
    d: "M210.3,203.9c9.7-5.6,17.6-1.2,17.6,9.8s-7.9,24.4-17.6,29.9s-17.6,1.1-17.6-9.8 C192.6,222.9,200.5,209.6,210.3,203.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st2",
    d: "M210.6,235.6c-0.8,0.5-1.6,0.5-2.2,0.1l-7.7-5.9c-1-0.8-0.9-2.9,0.3-4.8c1.2-1.9,3-2.8,4-2 l5.4,4.1l15-32.2c0.9-2,2.7-3.4,4-3c1.3,0.3,1.5,2.3,0.6,4.3L212.9,233c-0.5,1.1-1.3,2.1-2.2,2.6 C210.7,235.6,210.6,235.6,210.6,235.6z"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Cursor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_60_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_73_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_74_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st2",
    d: "M359.2,187.8l-4.9-2.9l0,0c-2.2-1.2-4.8,0-6.2,0.8L345,184l0,0c-3.7-2.3-9,2.5-10.1,3.6 l-1.3-0.8l0,0c-4-2.4-11.2,4-11.2,4V167l3.1-1.5l-5-2.9l0,0l0,0l0,0c-1.1-0.6-2.7-0.5-4.4,0.5l0,0c-3.5,2-6.3,6.9-6.3,11v55.3 c-4.6-3.4-9.4-5.5-13.7-4.7c-3.8,0.7-7.3,4-8.3,5.7c-2.1,3.7,1.4,6,5.8,11.1s8.3,11.1,12.4,14.9c4,3.8,6.9,4.7,6.9,4.7v7.2 l4.9,2.8l32.4-24.4v-7.2c0,0,4.6-18.5,6.1-26.2c1.4-7.4,2.7-19.3,0.3-25.4L359.2,187.8L359.2,187.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    className: "st3",
    d: "M359.2,187.8l-4.9-2.9l0,0c-2.2-1.2-4.8,0-6.2,0.8L345,184l0,0c-3.7-2.3-9,2.5-10.1,3.6 l-1.3-0.8l0,0c-4-2.4-11.2,4-11.2,4V167l3.1-1.5l-5-2.9l0,0l0,0l0,0c-1.1-0.6-2.7-0.5-4.4,0.5l0,0c-3.5,2-6.3,6.9-6.3,11v55.3 c-4.6-3.4-9.4-5.5-13.7-4.7c-3.8,0.7-7.3,4-8.3,5.7c-2.1,3.7,1.4,6,5.8,11.1s8.3,11.1,12.4,14.9c4,3.8,6.9,4.7,6.9,4.7v7.2 l4.9,2.8l32.4-24.4v-7.2c0,0,4.6-18.5,6.1-26.2c1.4-7.4,2.7-19.3,0.3-25.4L359.2,187.8L359.2,187.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_81_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    className: "st2",
    d: "M322.6,251.3l-24.5-14.2l-10.7-6.2c-1.4,3.3,1.9,5.7,6.1,10.5c4.4,5.1,8.3,11.1,12.4,14.9 c4,3.8,6.9,4.7,6.9,4.7v7.2l4.9,2.8l7.2-5.4C324,259.6,322.6,251.3,322.6,251.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_85_",
    className: "st2",
    points: "314.5,176.8 309.6,174 309.6,232 314.5,232.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    className: "st2",
    d: "M353,191.5l3.8-2.8c-0.1-0.2-0.2-0.5-0.3-0.7l1.4-0.1l-3-0.1l-5.1-2.8 c-0.7,0.3-1.3,0.6-1.7,0.9l1.6,0.9L353,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_83_",
    className: "st2",
    d: "M339.5,190.6l3.6-2.7l-4.9-3c-1.6,1-2.8,2.1-3.3,2.6l3.4,2L339.5,190.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_82_",
    className: "st2",
    points: "332.1,190.4 327.2,187.5 327.2,187.5 327.2,193.7 332.9,191.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_75_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    d: "M322.6,251.3l-24.5-14.2l-10.7-6.2c-1.4,3.3,1.9,5.7,6.1,10.5c4.4,5.1,8.3,11.1,12.4,14.9 c4,3.8,6.9,4.7,6.9,4.7v7.2l4.9,2.8l7.2-5.4C324,259.6,322.6,251.3,322.6,251.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_79_",
    points: "314.5,176.8 309.6,174 309.6,232 314.5,232.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_78_",
    d: "M353,191.5l3.8-2.8c-0.1-0.2-0.2-0.5-0.3-0.7l1.4-0.1l-3-0.1l-5.1-2.8c-0.7,0.3-1.3,0.6-1.7,0.9 l1.6,0.9L353,191.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_77_",
    d: "M339.5,190.6l3.6-2.7l-4.9-3c-1.6,1-2.8,2.1-3.3,2.6l3.4,2L339.5,190.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_76_",
    points: "332.1,190.4 327.2,187.5 327.2,187.5 327.2,193.7 332.9,191.6  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_67_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st2",
    d: "M317.7,271.1v-7.2c0,0-2.9-1-6.9-4.7s-7.9-9.9-12.4-14.9c-4.5-5.1-7.9-7.4-5.8-11.1 c1-1.8,4.4-5,8.3-5.7c4.3-0.8,9.1,1.3,13.7,4.7v-55.3c0-4,2.8-9,6.3-11l0,0c3.5-2,6.3-0.4,6.3,3.7v24.1c0,0,8.7-7.8,12.3-3 c0,0,8.6-9,12.5-1.4c0,0,6.3-5.1,9.2,0.8c2.8,5.9,1.5,18.4,0,26.1c-1.5,7.7-6.1,26.2-6.1,26.2v7.2L317.7,271.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_68_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    className: "st8",
    d: "M327.2,204c0,0,0.8-11,4.8-13.6h-0.1c-2.6,1.3-4.7,3.2-4.7,3.2v-0.2c0,0.1,0,0.2,0,0.2 L327.2,204L327.2,204z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_70_",
    className: "st8",
    d: "M339.5,190.6v10.1c0,0,1.1-10.4,3.4-12.9C341,189.1,339.5,190.6,339.5,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    className: "st8",
    d: "M352,189.2L352,189.2v10.1c0,0,0.6-10.2,2.8-11.7C353.2,188.3,352,189.2,352,189.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_61_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st5",
    d: "M316,156.1L316,156.1c-0.8,0.5-1.4,0.2-1.4-0.6v-8c0-0.8,0.6-1.8,1.4-2.2l0,0 c0.8-0.5,1.4-0.2,1.4,0.6v8C317.4,154.6,316.7,155.6,316,156.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    className: "st5",
    d: "M304,168.7L304,168.7c-0.6,1-1.5,1.5-2,1.2l-4.6-2.7c-0.6-0.3-0.6-1.4,0-2.3l0,0 c0.6-1,1.5-1.5,2-1.2l4.6,2.7C304.6,166.7,304.6,167.7,304,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    className: "st5",
    d: "M299.1,185.2v0.2c0,0.8-0.7,1.9-1.5,2.4l-6.3,3.7c-0.8,0.5-1.5,0.2-1.5-0.6v-0.2 c0-0.8,0.7-1.9,1.5-2.4l6.3-3.7C298.4,184.1,299.1,184.4,299.1,185.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st5",
    d: "M332.9,165.9v-0.2c0-0.8,0.7-1.9,1.5-2.4l6.3-3.7c0.8-0.5,1.5-0.2,1.5,0.6v0.2 c0,0.8-0.7,1.9-1.5,2.4l-6.3,3.7C333.5,167.1,332.9,166.8,332.9,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st5",
    d: "M327.9,154.9L327.9,154.9c-0.6-0.3-0.6-1.4,0-2.3l4.6-8c0.6-1,1.5-1.5,2-1.2l0,0 c0.6,0.3,0.6,1.4,0,2.3l-4.6,8C329.4,154.7,328.5,155.2,327.9,154.9z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.6c88c6f4d67c6c7d443020dea296485b.svg";
export { ForwardRef as ReactComponent };